import { useEffect, useState } from 'react';

const BP = { tablet: 768, desktop: 1024 };

function getBp(w) {
  if (w >= BP.desktop) return 'desktop';
  if (w >= BP.tablet) return 'tablet';
  return 'mobile';
}

export default function useBreakpoint() {
  const [bp, setBp] = useState(() =>
    typeof window === 'undefined' ? 'mobile' : getBp(window.innerWidth)
  );

  useEffect(() => {
    const onResize = () => setBp(getBp(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}
